export var InputPlacement;
(function (InputPlacement) {
    InputPlacement["bodyRightBottom"] = "BODYRIGHTBOTTOM";
    InputPlacement["footer"] = "FOOTER";
})(InputPlacement || (InputPlacement = {}));
//# sourceMappingURL=types.js.map